import { jsx as _jsx } from "react/jsx-runtime";
import { Chip } from "@air/primitive-chip";
import kebabCase from "lodash/kebabCase";
import { forwardRef } from "react";
import Linkify from "~/components/Linkify";
export const CustomField = /*#__PURE__*/ forwardRef((param, forwardedRef)=>{
    let { field, ...restOfProps } = param;
    return /*#__PURE__*/ _jsx(Chip, {
        color: kebabCase(field.color.name),
        "data-testid": "CUSTOM_FIELD",
        "data-id": field.id,
        "data-color": field.color.name,
        "data-value": field.value,
        shape: "rectangular",
        size: "medium",
        ...restOfProps,
        ref: forwardedRef,
        children: /*#__PURE__*/ _jsx("span", {
            className: "truncate",
            children: /*#__PURE__*/ _jsx(Linkify, {
                children: field.value
            })
        })
    });
});
CustomField.displayName = "CustomField";
